//
/**
 * Function round() makes a perfect number rounding by working with numbers as strings.
 * It is needed because some numbers have no binary representation and cannot be
 * rounded properly
 *
 * @param number {number}
 * @param precision {number}
 */
export const round = (number, precision = 2) => {
  const shift = (number, exponent) => {
    let numArray = ('' + number).split('e');
    return +(numArray[0] + 'e' + (numArray[1] ? +numArray[1] + exponent : exponent));
  };
  return shift(Math.round(shift(number, +precision)), -precision);
};

const addSpaces = (number, defaultFloating = true) => {
  if (number) {
    number = round(number).toString();
    let [, integ, floating = defaultFloating ? '.00' : ''] = number.match(/(-?\d+)(\.\d+)?/i) || [
      '',
      '0',
      '.00',
    ];
    integ = integ
      ? integ
          .replace(/[^-\d]/g, '')
          .split('')
          .reverse()
          .join('')
      : '';
    let matches = integ.match(/.{1,3}-?/g);
    integ = integ !== '' ? matches.join(' ') : '';

    number = integ.split('').reverse().join('') + floating;
    return number;
  } else {
    return '0.00';
  }
};

export default addSpaces;

/**
 * Function that takes a big number, rounds it to million and returns 7.3M or normal spaced number
 * @param number {number}
 */
export const formatMoney = (number) => {
  if (number) {
    number = round(number).toString();
    const [, integ] = number.match(/(\d+)(\.\d+)?/i) || ['', '0', '.00'];

    const negative = number.indexOf('-') > -1;
    const minus = negative ? '-' : '';

    if ((integ.length > 6 && !negative) || integ.length > 7) {
      return minus + round(integ / 1000000) + 'M';
    } else if ((integ.length > 3 && !negative) || integ.length > 4) {
      return minus + round(integ / 1000) + 'K';
    } else {
      return addSpaces(number);
    }
  } else {
    return '0.00';
  }
};
